<template>
  <div id="class-detail">
    <div class="page-center">
      <!-- 头部 -->
      <div class="class-detail-header">
        <div class="class-detail-title">{{ course.name && course.name.length > 20 ? course.name.substring(0, 20) + '...' : course.name }}</div>
        <div class="class-detail-desc">
          <div class="left-content">
            <img src="../../assets/imgs/acadmy/info_speaker.png">
            <span>{{ course.lecturer && course.lecturer.length > 20 ? course.lecturer.substring(0, 20) + '...' : course.lecturer }}</span>
          </div>
          <div class="right-content">
            <div class="read-count">
              <img src="../../assets/imgs/acadmy/view.png">
              <span>{{ course.learn_times }}</span>
            </div>
            <div class="share-wx">
              <div class="share-btn">
                <img src="../../assets/imgs/acadmy/wechat_share.png">
                <span>分享到微信</span>
              </div>
              <div class="wx-qrcode-box" v-if="qrcodeUrl">
                <div class="wx-qrcode-inner">
                  <div class="center-logo">
                    <img src="../../assets/imgs/logo.jpg">
                  </div>
                  <qrcode-vue :value="qrcodeUrl" :size="160" level="H"></qrcode-vue>
                </div>
                <div class="wx-qrcode-tips">打开微信，使用"扫一扫"</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 视频 -->
      <div class="class-video-box">
        <div class="video-content">
          <div class="video-area">
            <div class="class-video-center"></div>
            <div class="video-iframe-wrap" v-html="course.tx_video_code"></div>
            <div class="video-error" v-show="!videoLinkValid">
              <img src="../../assets/imgs/acadmy/video_wrong.png">
              <span>视频出错了</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 内容 -->
      <div class="class-text-content">
        <div class="class-text-title">课程介绍</div>
        <div class="class-content" v-html="course.introduction"></div>
      </div>

      <!-- 继续学习 -->
      <div class="continue-study" v-if="others && others.length > 0">
        <div class="continue-study-title">继续学习</div>
        <ul class="continue-classes">
          <li v-for="course in others" :key="course.course_id" @click="goToCourseDetail(course)">
            <div class="learn_times">
              <img src="../../assets/imgs/acadmy/view_shadow.png">
              <span>{{ course.learn_times }}</span>
            </div>
            <img class="class-img" :src="course.cover_img">
            <div class="class-desc">{{ course.name }}</div>
          </li>
        </ul>
      </div>
    </div>
    <join-now v-if="!User.isLogin()"></join-now>
  </div>
</template>

<script>
import _ from 'lodash';
import sensorsdata from 'sa-sdk-javascript';
import QrcodeVue from 'qrcode.vue';
import User from '@/libs/user';
import joinNow from '../index/components/join-now';
import Http from '../../libs/http';
import visaAcademyService from '../../services/visa-academy-service';
import { envPrefix } from '../../libs/env';

const fromType = {
  1: '最新课程',
  2: '课程目录',
  3: '继续学习',
  4: '好友分享',
};

export default {
  name: 'class-detail',
  components: {
    joinNow,
    QrcodeVue,
  },
  data() {
    return {
      User,
      courseId: +this.$route.params.courseId,
      from: this.$route.query.from ? +this.$route.query.from : 0,
      course: {},
      others: [],
      qrcodeUrl: `https://${envPrefix}h5.666visa.cn/#/visa-class/${+this.$route.params.courseId}`,
    };
  },
  computed: {
    videoLinkValid() {
      return this.course &&
             this.course.tx_video_code &&
             _.startsWith(this.course.tx_video_code, '<iframe') &&
             _.endsWith(this.course.tx_video_code, '></iframe>');
    },
  },
  methods: {
    getCourseDetail(courseId) {
      Http.post('/sys/visa_course_query', { course_id: courseId }).then((data) => {
        this.course = data.course;
        this.others = data.others;
        if (this.from) {
          sensorsdata.track('CourseDetail', {
            source: fromType[this.from],
            course_name: this.course.name,
          });
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    goToCourseDetail(course) {
      sensorsdata.track('CourseDetailMore', {
        course_name: course.name,
      });
      visaAcademyService.goToCourseDetail(course, 3, this.$router);
    },
  },
  watch: {
    $route() {
      const courseId = this.$route.params.courseId;
      if (courseId) {
        this.courseId = +courseId;
        this.from = this.$route.query.from ? +this.$route.query.from : 0;
        this.getCourseDetail(this.courseId);
      }
    },
  },
  created() {
    this.getCourseDetail(this.courseId);
  },
};
</script>

<style lang="less">
#class-detail {
  position: relative;
  display: flex;
  flex-direction: column;
  .page-center {
    width: 1000px;
    margin: 0 auto 60px auto;
    background-color: #ffffff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-top: 20px;
    .class-detail-header {
      display: flex;
      flex-direction: column;
      padding: 40px 40px 35px 40px;
      .class-detail-title {
        font-size: 28px;
        font-weight: 600;
        color: #333;
      }
      .class-detail-desc {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        .left-content {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          span {
            font-size: 18px;
            color: #6f6f6f;
            margin-left: 10px;
          }
        }
        .right-content {
          display: flex;
          align-items: center;
          .read-count {
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
            }
            span {
              font-size: 14px;
              color: #aaa;
              margin-left: 5px;
            }
          }
          .share-wx {
            margin-left: 40px;
            display: flex;
            align-items: center;
            position: relative;
            .share-btn:hover +.wx-qrcode-box {
              display: flex;
            }
            .share-btn {
              cursor: pointer;
              display: flex;
              align-items: center;
              img {
                width: 20px;
                height: 20px;
              }
              span {
                font-size: 14px;
                color: #aaa;
                margin-left: 5px;
              }
            }
            .wx-qrcode-box {
              position: absolute;
              z-index: 3;
              display: none;
              flex-direction: column;
              height: 224px;
              width: 200px;
              left: 50%;
              top: 30px;
              border-radius: 4px;
              transform: translateX(-50%);
              align-items: center;
              justify-content: center;
              padding: 20px;
              background-color: white;
              box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
              z-index: 5;
              &::before {
                content: '';
                position: absolute;
                top: -10px;
                left: 50%;
                transform: translate(-10px);
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 10px solid #fff;
                z-index: 2;
              }
              &::after {
                content: '';
                position: absolute;
                top: -11px;
                left: 50%;
                transform: translate(-11px);
                border-left: 11px solid transparent;
                border-right: 11px solid transparent;
                border-bottom: 11px solid rgba(0, 0, 0, 0.1);
                z-index: 1;
              }
              .wx-qrcode-inner {
                overflow: hidden;
                background-color: #ffffff;
                position: relative;
                height: 160px;
                width: 160px;
                .center-logo {
                  position: absolute;
                  width: 40px;
                  height: 40px;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  img {
                    width: 40px;
                    height: 40px;
                  }
                }
              }
              .wx-qrcode-tips {
                font-size: 14px;
                line-height: 14px;
                color: #333;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .class-video-box {
      padding: 0 40px 30px 40px;
      border-bottom: 1px dashed #f0f0f0;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .video-content {
        position: relative;
        background-color: #fbfbfb;
        width: 100%;
        padding: 30px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .video-area {
          position: relative;
          .class-video-center {
            width: 720px;
            padding-bottom: 56.25%;
            height: 0;
            background-color: #fbfbfb;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .video-iframe-wrap {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            z-index:2;
            iframe {
              width: 100%;
              height: 100%;
            }
          }
          .video-error {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
            background-color: #f3f4f6;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img {
              width: 63px;
              height: 46px;
            }
            span {
              font-size: 16px;
              color: #aaa;
              margin-top: 20px;
            }
          }
        }
      }
    }
    .class-text-content {
      display: flex;
      flex-direction: column;
      padding: 40px 30px;
      border-bottom: 1px dashed #f0f0f0;
      .class-text-title {
        font-size: 18px;
        line-height: 1;
        color: #333;
        font-weight: 600;
        padding-left: 11px;
        position: relative;
        &::before {
          width: 3px;
          height: 18px;
          background-color: #5e9be1;
          border-radius: 2px;
          content: '';
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .class-content {
        margin-top: 30px;
        padding-left: 11px;
      }
    }
    .continue-study {
      padding: 40px 30px;
      .continue-study-title {
        font-size: 18px;
        color: #333;
        font-weight: 600;
        padding-left: 11px;
        position: relative;
        &::before {
          width: 3px;
          height: 18px;
          background-color: #5e9be1;
          border-radius: 2px;
          content: '';
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .continue-classes {
        list-style-type: none;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        position: relative;
        li {
          display: flex;
          flex-direction: column;
          position: relative;
          cursor: pointer;
          width: 290px;
          overflow: hidden;
          .learn_times {
            position: absolute;
            right: 7px;
            top: 5px;
            display: flex;
            align-items: center;
            img {
              margin-right: 5px;
              border-radius: 2px;
            }
            span {
              font-size: 12px;
              color: white;
              text-shadow: 0px 0 4px rgba(0, 0, 0, 0.25);
            }
          }
          .class-img {
            width: 290px;
            height: 174px;
            background-color: #5e9be1;
            border: 1px solid #f0f0f0;
            border-radius: 4px;
          }
          .class-desc {
            font-size: 16px;
            color: #333;
            margin-top: 13px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/ClassDetail.vue